const { createSlice } = require("@reduxjs/toolkit");

const deliveryAddress = createSlice({
    name: "DeliveryAddress",
    initialState: [],
    reducers:{
        setDeliveryAddress(state,action){
            state.push(action.payload)
        }
    }
});

export const {setDeliveryAddress} = deliveryAddress.actions;
export default deliveryAddress.reducer;